import {
  HTTP_DELETESPECIAL_FETCHING,
  HTTP_DELETESPECIAL_SUCCESS,
  HTTP_DELETESPECIAL_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_DELETESPECIAL_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_DELETESPECIAL_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_DELETESPECIAL_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
